<template>
  <div class="wrapper">
    <van-notice-bar v-if="this.codeStatus == 4" :text="'订单状态：' + orderStatusMap[status]" />
    <div class="form">
      <van-form @submit="onSubmit">
        <div class="formWrapper">
          <div class="panel" v-if="this.codeStatus == '4' && this.status == '2'">
            <div class="title">未通过原因</div>
            <div class="discription" style="color: red">
              <van-icon name="warning-o" /> {{ this.formData.failedReason }}
            </div>
          </div>
          <div class="panel">
            <div class="title">激活码信息</div>
            <van-field v-model="formData.code" disabled name="code" label="激活码" required placeholder="请输入激活码"
              :rules="[{ required: true, message: '请填写激活码' }]">
              <!-- <van-icon @click="onScan" slot="right-icon" name="scan" /> -->
            </van-field>
          </div>
          <div class="panel">
            <div class="title">用户信息</div>
            <van-field v-model="formData.name" name="name" label="取件联系人" :readonly="this.codeStatus != '1' && !isEdit"
              required placeholder="请输入取件联系人" :rules="[{ required: true, message: '请填写取件联系人' }]" />
            <van-field v-model="formData.phone" name="phone" :readonly="this.codeStatus != '1' && !isEdit"
              :maxlength="11" type="tel" label="取件联系方式" required placeholder="请输入取件联系方式" :rules="[
                { required: true, message: '请填写取件联系方式' },
                {
                  message: '手机号码格式错误,请重新输入',
                  pattern: /0?(13|14|15|16|17|18|19)[0-9]{9}/,
                },
              ]" />
            <van-field v-model="formData.getAddress" :readonly="this.codeStatus != '1' && !isEdit" clickable
              name="picker" required label="取件地址" :rules="[{ required: true, message: '请选择取件地址' }]"
              placeholder="点击选省/市/区" @click="showArea = true" />
            <van-field v-model="formData.getAddressDetail" name="name" :readonly="this.codeStatus != '1' && !isEdit"
              label="取件详细地址" required placeholder="请输入取件详细地址" :rules="[{ required: true, message: '请填写取件详细地址' }]" />
            <van-cell center title="回件是否同收件一致">
              <template #right-icon>
                <van-switch size="24px" v-model="isSame" @click="switchClick" />
              </template>
            </van-cell>
            <van-field v-model="formData.postUsername" v-if="!isSame" :readonly="this.codeStatus != '1' && !isEdit"
              name="name" label="回件联系人" required placeholder="请输入回件联系人"
              :rules="[{ required: true, message: '请填写回件联系人' }]" />
            <van-field v-model="formData.postContactWay" v-if="!isSame" :readonly="this.codeStatus != '1' && !isEdit"
              name="phone" :maxlength="11" type="tel" label="回件联系方式" required placeholder="请输入回件联系方式" :rules="[
                { required: true, message: '请填写回件联系方式' },
                {
                  message: '手机号码格式错误,请重新输入',
                  pattern: /0?(13|14|15|16|17|18|19)[0-9]{9}/,
                },
              ]" />
            <van-field :readonly="this.codeStatus != '1' && !isEdit" v-if="!isSame" v-model="formData.postAddress"
              clickable name="picker" required label="回件地址" :rules="[{ required: true, message: '请选择回件地址' }]"
              placeholder="点击选省/市/区" @click="showArea2 = true" />
            <van-field :readonly="this.codeStatus != '1' && !isEdit" v-if="!isSame" v-model="formData.postAddressDetail"
              name="name" label="回件详细地址" required placeholder="请输入回件详细地址"
              :rules="[{ required: true, message: '请填写回件详细地址' }]" />
          </div>
          <div class="panel">
            <div class="title">履约类型</div>
            <van-checkbox-group v-model="formData.orderType">
              <van-cell-group>

                <div v-for="item in orderTypeList" :key="item.key">
                  <van-cell clickable
                    v-if="(item.key != 6 && item.key != 7) || ((item.key == 6 || item.key == 7) && groupTag == 1)"
                    :title="item.type" @click="toggle(item.key)">
                    <template #right-icon>
                      <van-checkbox :name="item.key" :ref="'checkboxes' + item.key" />
                    </template>
                  </van-cell>
                </div>

              </van-cell-group>
            </van-checkbox-group>
            <!-- 其他： -->
            <div v-if="this.formData.orderType.includes(4)">
              <van-field v-model="otherExtend" name="name" label="其他原因" placeholder="请输入其他"
                :rules="[{ required: true, message: '请填写其他' }]" />
            </div>


            <div v-if="formData.orderType.some(element => hasMalfunctionImplementatioIds.includes(element))">
              <div>
                <van-field readonly clickable label="换机故障类型" :value="malfunctionName" placeholder="请选择故障类型"
                  @click="showMalfunctionPicker = true" />
                <van-popup v-model="showMalfunctionPicker" round position="bottom">
                  <van-picker show-toolbar title="请选择故障类型" :columns="malfunctionColumn"
                    @cancel="showMalfunctionPicker = false" @confirm="onMalfunctionConfirm" />
                </van-popup>
              </div>
              <div>
                <van-field readonly clickable label="履约服务" :value="serviceName" placeholder="请选择履约服务"
                  @click="showServicePicker = true" />
                <van-popup v-model="showServicePicker" round position="bottom">
                  <van-picker show-toolbar title="请选择履约服务" :columns="serviceColumn" @cancel="showServicePicker = false"
                    @confirm="onServiceConfirm" />
                </van-popup>
              </div>

              <div v-if="serviceId">
                <van-field readonly clickable :label="serviceId == 1 ? '换机型号' : '换机新机'" :value="newName" :placeholder="
                     serviceId == 1 ? '请选择换机型号' : '请选择新机型号'
                   " @click="
                     showNewModelPicker = true;
                     searchValue = '';
                   " />
                <van-popup v-model="showNewModelPicker" round position="bottom">
                  <van-picker show-toolbar :title="
                       serviceId == 1 ? '请选择换机型号' : '请选择新机型号'
                     " :columns="filterModelCol" @cancel="showNewModelPicker = false" @confirm="onNewModelConfirm">
                    <slot slot="title">
                      <van-search style="padding: 0" v-model="searchValue" placeholder="输入搜索机型" />
                    </slot>
                  </van-picker>
                </van-popup>
              </div>


              <div v-if="serviceId && serviceId == 2">
                <van-field readonly clickable label="换机旧机" :value="`${oldName}`" placeholder="请选择旧机型号" @click="
                     showOldModelPicker = true;
                     searchValue = '';
                   " />
                <van-popup v-model="showOldModelPicker" round position="bottom">
                  <van-picker show-toolbar title="请选择旧机型号" :columns="filterModelCol"
                    @cancel="showOldModelPicker = false" @confirm="onOldModelConfirm">
                    <slot slot="title">
                      <van-search style="padding: 0" v-model="searchValue" placeholder="输入搜索机型" />
                    </slot>
                  </van-picker>
                </van-popup>
              </div>
              <div v-if="newModelId && oldModelId">
                <van-field label="JD津贴" :value="supPayment2" readonly />
              </div>
              <block v-if="!isShow">
                <div v-if="newModelId">
                  <van-field label="新机价格" :value="newAmount" readonly />
                </div>

                <div v-if="serviceId == 2 && oldModelId">
                  <van-field label="旧机价格" :value="oldAmount" readonly />
                </div>

                <div v-if="newModelId && oldModelId">
                  <van-field label="顾客支付" :value="supPayment" readonly />
                </div>
              </block>

              <block v-if="newName && serviceId==1? true : oldName">
                <div @click="isShow=!isShow" style="margin-left: 16px;font-size: 16px;color: #06B4FD">
                  <block v-if="isShow">
                    更多
                    <van-icon name="arrow-down" color="#06B4FD" />
                  </block>
                  <block v-else>
                    收起
                    <van-icon name="arrow-up" color="#06B4FD" />
                  </block>
                </div>
              </block>

            </div>

          </div>
          <div class="panel">
            <div class="title">屏幕状态</div>
            <div class="discription">
              提示:
              <p>
                售后电话：<a class="tel" href="tel:4006111232">4006111232</a>
              </p>
              <p>
                故障商品整机正面（显示IMEI号/出厂序列号/SN码）照片；不能开机正常显示的，提供带串号的机身/发票/保修卡/包装盒照片（机打和手写同样有效）
              </p>
            </div>
            <div :key="item.uploadKey" v-for="item in imgList">
              <div v-if="item.show">
                <div class="title">{{ item.tip }}</div>
                <van-button v-if="formData[item.uploadKey]" @click="
                    (e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      openPreview([item.showImgUrl]);
                    }
                  ">
                  预览图片
                </van-button>
                <van-uploader accept="image/*" :disabled="!isEdit && codeStatus != 1"
                  :after-read="(file) => afterRead(file, item.uploadKeyNum)" :max-size="20 * 1024 * 1024"
                  @oversize="overSizeTip">
                 <img v-if="formData[item.uploadKey]" style="width: 100%" :src="item.showImgUrl" />
                  <van-button v-else :class="`upladerBtn upladerBtn${item.uploadKeyNum}`" icon="plus"
                    type="primary"></van-button>
                </van-uploader>
              </div>
            </div>
            <div class="icon-box">
              <van-icon size='25' style="margin-right: 20px" v-if="!imgList[12].show" name="add-o" @click="addImgFun" />
              <van-icon size='25' v-if="imgList[2].show" name="close" @click="reduceImgFun" />
            </div>
          </div>
        </div>
        <div style="margin: 16px">
          <van-button v-if="this.codeStatus == '1' || isEdit" round block type="danger"
            native-type="submit">提交</van-button>
        </div>
      </van-form>
      <div v-if="this.codeStatus == '4' && (this.status == 2 || this.status == 6)" style="margin: 16px">
        <van-button v-if="!isEdit" round block type="danger" @click="onEdit">修改信息</van-button>
      </div>
      <van-popup v-model="showArea" position="bottom">
        <van-area @confirm="onConfirm" @cancel="showPicker = false" :area-list="areaList"
          :columns-placeholder="['请选择', '请选择', '请选择']" />
      </van-popup>
      <van-popup v-model="showArea2" position="bottom">
        <van-area @confirm="onConfirm2" @cancel="showPicker2 = false" :area-list="areaList"
          :columns-placeholder="['请选择', '请选择', '请选择']" />
      </van-popup>
    </div>
    <loadingMask :isShow="showLoding" />
  </div>
</template>

<script>
  import loadingMask from "@/components/loadingMask.vue";
  import {
    baseURL
  } from "@/config";
  import areaList from "@/utils/area";
  import {
    addOrder,
    uploadOrderImg,
    userGetOrder,
    userUpdateOrder,
    getUserInfo,
    getModelList,
    getMalfunctionList,
    getFormula,
    getFormula2,
    getListByTypeId,
    getMalfunctionListByImplementationId
  } from "@/api";
  import {
    orderStatusMap,
    checkImgFun
  } from "@/utils/common";
  import {
    openPreview
  } from "@/utils";

  export default {
    name: "activationCode",
    data() {
      return {
        isShow: true,
        columns: [{
            text: "杭州",
            disabled: true
          },
          {
            text: "宁波"
          },
          {
            text: "温州"
          },
        ],
        typeId: null,
        malfunctionList: [],
        malfunctionName: "",
        malfunctionId: "",
        initMalfunctionColumn: [],
        malfunctionColumn: [],
        showMalfunctionPicker: false,
        modelList: [],
        modelColumn: [],
        oldName: "",
        oldModelId: "",
        showOldModelPicker: false,
        newName: "",
        newModelId: "",
        showNewModelPicker: false,
        formData: {
          name: "", // 联系人
          phone: "", // 联系方式
          getAddress: "", // 取件地址
          getAddressDetail: "", // 取件详细地址
          postContactWay: "",
          postUsername: "",
          postAddress: "", // 回件地址
          postAddressDetail: "", // 回件详细地址
          code: "", // 激活码
          goodsPicture: "",
          goodsPicture2: "",
          orderType: [],
        },
        groupTag: "0",
        otherExtend: "",
        orderTypeList: [
          // {
          //   key: 1,
          //   type: "碎屏",
          // },
          // {
          //   key: 2,
          //   type: "后盖",
          // },
          // {
          //   key: 3,
          //   type: "电池",
          // },
          // {
          //   key: 5,
          //   type: "延保",
          // },
          // {
          //   key: 6,
          //   type: "换机",
          // },
          // {
          //   key: 7,
          //   type: "180产品",
          // },
          // {
          //   key: 4,
          //   type: "其他",
          // },
        ],
        hasMalfunctionImplementatioIds: [],
        showServicePicker: false,
        serviceId: "",
        serviceName: "",
        baseURL,
        isEdit: false,
        orderStatusMap,
        areaList,
        showArea: false,
        showArea2: false,
        isSame: true,
        showLoding: false,
        imgList: [{
            show: true,
            uploadKey: "goodsPicture",
            uploadKeyNum: "1",
            showImgUrl: "",
            tip: "照片1:白屏正面照（带串号、附身份证）",
          },
          {
            show: true,
            uploadKey: "goodsPicture2",
            uploadKeyNum: "2",
            showImgUrl: "",
            tip: "照片2：背面照",
          },
          {
            show: false,
            uploadKey: "goodsPicture3",
            uploadKeyNum: "3",
            showImgUrl: "",
            tip: "照片3：正面黑屏照片",
          },
          {
            show: false,
            uploadKey: "goodsPicture4",
            uploadKeyNum: "4",
            showImgUrl: "",
            tip: "照片4：手机顶部照片",
          },
          {
            show: false,
            uploadKey: "goodsPicture5",
            uploadKeyNum: "5",
            showImgUrl: "",
            tip: "照片5：手机尾部照片",
          },
          {
            show: false,
            uploadKey: "goodsPicture6",
            uploadKeyNum: "6",
            showImgUrl: "",
            tip: "照片6：手机左侧照片",
          },
          {
            show: false,
            uploadKey: "goodsPicture7",
            uploadKeyNum: "7",
            showImgUrl: "",
            tip: "照片7：手机右侧照片",
          },
          {
            show: false,
            uploadKey: "goodsPicture8",
            uploadKeyNum: "8",
            showImgUrl: "",
            tip: "照片8：沙漏验机截图",
          },
          {
            show: false,
            uploadKey: "goodsPicture9",
            uploadKeyNum: "9",
            showImgUrl: "",
            tip: "照片9：面容识别重新录制照片",
          },
          {
            show: false,
            uploadKey: "goodsPicture10",
            uploadKeyNum: "10",
            showImgUrl: "",
            tip: "照片10：摄像头拍照（后置摄像头）",
          },
          {
            show: false,
            uploadKey: "goodsPicture11",
            uploadKeyNum: "11",
            showImgUrl: "",
            tip: "照片11：摄像头拍照（前置摄像头）",
 
          },
          {
            show: false,
            uploadKey: "goodsPicture12",
            uploadKeyNum: "12",
            showImgUrl: "",
            tip: "照片12：接件单照片",
          },
          {
            show: false,
            uploadKey: "goodsPicture13",
            uploadKeyNum: "13",
            showImgUrl: "",
                       
            tip: "照片13：换机审核通过，上传完结新机照片",
          },
        ],
        newAmount: 0,
        oldAmount: 0,
        codeStatus: this.$route.query.codeStatus,
        code: this.$route.query.code,
        searchValue: "",
        status: "",
        modelMap: {},
        malfunctionMap: {},
        serviceColumn: [{
            value: "1",
            text: "同代同型换新机"
          },
          {
            value: "2",
            text: "迭代升级换新机"
          },
        ],
      };
    },
    components: {
      loadingMask,
    },
    async mounted() { 
      this.formData.code = this.$route.query.code;
      this.formData.codeId = Number(this.$route.query.codeId);
      window.document.title = "报修";
      await this.getModelListFun();
      await this.getMalfunctionListFun();
      await this.getFormulaFun();
      this.getUserInfoFun();
      if (this.codeStatus == 4 || this.codeStatus == 5) {
        this.userGetOrderFun();
      }
    },
    computed: {
      supPayment: function() {
        // eslint-disable-next-line one-var
        let x = 0,
          y = 0,
          z = 0;
        x = Number(this.newAmount);
        y = Number(this.oldAmount);
        z = Number(this.malfunctionMap[this.malfunctionId]);

        // this.newModelId
        return this.formulaCalc(x, y, z);
      },
      supPayment2: function() {
        // eslint-disable-next-line one-var
        let x = 0,
          y = 0,
          z = 0;
        x = Number(this.newAmount);
        y = Number(this.oldAmount);
        z = Number(this.malfunctionMap[this.malfunctionId]);

        // this.newModelId
        return this.formulaCalc2(x, y, z);
      },
      filterModelCol: function() {
        return this.searchValue ?
          this.modelColumn.filter((v) => v.text.includes(this.searchValue)) :
          this.modelColumn;
      },
    },
    methods: {
      openPreview,
      addImgFun() {
        console.log(this.imgList)
        for (let i = 2; i < 13; i++) {
          if (!this.imgList[i].show) {
            this.imgList[i].show = true
            // break;
          }
        }
      },
      reduceImgFun() {
        for (let i = 12; i > 1; i--) {
          if (this.imgList[i].show) {
            this.imgList[i].show = false
            this.imgList[i].showImgUrl = ''
            let key = `goodsPicture${i+1}`
            this.formData[key] = ''
            break;
          }
        }
      },
      onMalfunctionConfirm(value) {
        this.malfunctionName = value.text;
        this.malfunctionId = value.value;
        this.showMalfunctionPicker = false;
      },
      onNewModelConfirm(value) {
        this.newName = value.text;
        this.newModelId = value.value;
        this.newAmount = value.newAmount;
        if (this.serviceId == 1) {
          this.oldName = value.text;
          this.oldModelId = value.value;
          this.oldAmount = value.newAmount;
        }
        this.showNewModelPicker = false;
      },
      onOldModelConfirm(value) {
        this.oldName = value.text;
        this.oldModelId = value.value;
        this.oldAmount = value.oldAmount;
        this.showOldModelPicker = false;
      },
      onServiceConfirm(value) {
        this.serviceName = value.text;
        this.serviceId = value.value;
        this.oldName = "";
        this.oldModelId = "";
        this.oldAmount = 0;
        this.newName = "";
        this.newModelId = "";
        this.newAmount = 0;
        this.showServicePicker = false;
      },
      toggle(key) {

        console.log("hasMalfunctionImplementatioIds - - - ", this.hasMalfunctionImplementatioIds);

        // 选择的履约类型key 有故障类型：单选 只能选这一个 和其他
        if (this.hasMalfunctionImplementatioIds.includes(key)) {
          const refKey = "checkboxes" + key;

          this.oldName = "";
          this.oldModelId = "";
          this.newName = "";
          this.newModelId = "";
          this.malfunctionName = "";
          this.malfunctionId = "";
          this.serviceId = "";
          this.serviceName = "";

          // 清空其它非有ids的key key===4不操作
          const types = JSON.parse(JSON.stringify(this.formData.orderType))
          if (types) {
            types.forEach(key => {
              if (key !== 4) {
                const typeRefKey = "checkboxes" + key;
                this.$refs[typeRefKey][0].toggle();
              }
            })
          }

          // 当前key
          this.$refs[refKey][0].toggle();

          this.getMalfunctionListByKey(key)

        } else {
          this.malfunctionColumn = JSON.parse(JSON.stringify(this.initMalfunctionColumn))

          if (key !== 4) {
            // 清空有ids的key
            const types = JSON.parse(JSON.stringify(this.formData.orderType))
            if (types) {
              types.forEach(key => {
                if (key !== 4 && this.hasMalfunctionImplementatioIds.includes(key)) {
                  const typeRefKey = "checkboxes" + key;
                  this.$refs[typeRefKey][0].toggle();
                }
              })
            }
            this.oldName = "";
            this.oldModelId = "";
            this.newName = "";
            this.newModelId = "";
            this.malfunctionName = "";
            this.malfunctionId = "";
            this.serviceId = "";
            this.serviceName = "";
          }
          // 当前key
          const refKey = "checkboxes" + key;
          this.$refs[refKey][0].toggle();
        }
        console.log("formData.orderType - - - ", this.formData.orderType);

      },
      onEdit() {
        this.isEdit = true;
      },
      overSizeTip() {
        this.$toast("上传图片不能超过20M");
      },
      switchClick() {
        this.isSame = !this.isSame;
      },
      onSubmit(e) {
        if (!this.formData.goodsPicture || !this.formData.goodsPicture2) {
          this.$toast("请上传图片");
          return;
        }
        if (!this.formData.orderType) {
          this.$toast("请选择履约类型");
          return;
        }
        this.showLoding = true;
        if (this.isSame) {
          this.formData.postAddress = this.formData.getAddress;
          this.formData.postAddressDetail = this.formData.getAddressDetail;
          this.formData.postUsername = this.formData.name;
          this.formData.postContactWay = this.formData.phone;
        }
        let fun =
          this.codeStatus == "4" && (this.status == 2 || this.status == 6) ?
          userUpdateOrder :
          addOrder;

        let params = {
          ...this.formData,
        };
        params.orderType = {
          types: params.orderType,
        };
        if (params.orderType.types.includes(4)) {
          params.orderType["otherExtend"] = this.otherExtend;
        }

        if (this.formData.orderType.some(element => this.hasMalfunctionImplementatioIds.includes(element))) {
          const newAmount = Number(this.modelMap[this.newModelId].newAmount);
          const oldAmount = Number(this.modelMap[this.oldModelId].oldAmount);
          const malfunctionAmount = Number(
            this.malfunctionMap[this.malfunctionId]
          );
          params.malfunctionId = this.malfunctionId;
          params.malfunctionName = this.malfunctionName;
          params.malfunctionAmount = malfunctionAmount;
          params.oldModelId = this.oldModelId;
          params.oldName = this.oldName;
          params.oldAmount = oldAmount;
          params.newModelId = this.newModelId;
          params.newName = this.newName;
          params.newAmount = newAmount;
          params.serviceId = this.serviceId;
          params.serviceName = this.serviceName;
          params.payment = this.supPayment;
          params.payment2 = this.supPayment2;
        }
        params.orderType = JSON.stringify(params.orderType);

        // console.log("params - - - -", params);
        // return

        fun(params).then((res) => {
          const response = res.data;
          if (response.code === "200") {
            this.$toast.success({
              message: "信息已提交，等待工作人员审核",
              duration: 5000,
            });
          } else {
            this.$toast.fail(response.msg);
          }
          this.showLoding = false;
        });
      },


      onConfirm(area) {
        let areaName = "";
        area.forEach((v) => {
          areaName += v.name;
        });
        this.formData.getAddress = areaName;
        this.showArea = false;
      },
      onConfirm2(area) {
        let areaName = "";
        area.forEach((v) => {
          areaName += v.name;
        });
        this.formData.postAddress = areaName;
        this.showArea2 = false;
      },
      userGetOrderFun() {
        userGetOrder({
          code: this.code
        }).then((res) => {
          const response = res.data;
          console.log(response);
          if (response.code == 200) {
            let data = response.data[0];
            this.serviceName = data.serviceName;
            this.serviceId = data.serviceId;
            this.malfunctionId = data.malfunctionId;
            this.malfunctionName = data.malfunctionName;
            this.oldModelId = data.oldModelId;
            this.oldAmount = data.oldAmount;
            this.oldName = data.oldName;
            this.newModelId = data.newModelId;
            this.newName = data.newName;
            this.newAmount = data.newAmount;
            try {
              let orderType = JSON.parse(data.orderType);
              data.orderType = orderType.types;
              this.otherExtend = orderType.otherExtend;
            } catch (error) {}
            this.formData = data;
            this.status = response.data[0].status;
            for (let i = 0; i < 12; i++) {
              let key = "goodsPicture";
              if (i > 0) {
                key = key + (i + 1);
              }
              if (this.formData[key]) {
                checkImgFun(this.formData[key]).then((url) => {
                  this.imgList[i].showImgUrl = url;
                  if (i > 1) {
                    this.imgList[i].show = true;
                  }
                });
              }
            }
            this.isSame = false;
          }
        });
      },
      afterRead(file, pictureNum) {
        console.log(file);
        this.showLoding = true;
        var formData = new FormData();
        formData.append("picture", file.file);
        formData.append("code", this.code);
        formData.append(
          "name",
          `goods_picture${pictureNum > 1 ? pictureNum : ""}`
        );
        uploadOrderImg(formData)
          .then((res) => {
            const response = res.data;
            if (response.code === "200") {
              this.formData["goodsPicture" + (pictureNum > 1 ? pictureNum : "")] =
                response.data;
              checkImgFun(response.data).then((url) => {
                this.imgList[pictureNum - 1].showImgUrl = url;
              });
              this.$toast.success("上传成功");
            } else {
              this.$toast.fail(response.msg);
            }
            this.showLoding = false;
          })
          .catch(() => {
            this.$toast.fail("上传失败,请重新上传");
            this.showLoding = false;
          });
      },
      getUserInfoFun() {
        getUserInfo({
          keyword: this.code,
        }).then((res) => {
          const response = res.data;
          if (response.code === "200") {
            const data = response.data[0];
            this.groupTag = data.groupTag;

            if (!!data.typeId) {
              this.typeId = data.typeId
              this.getMListByTypeId()
            }
          }
        });
      },
      getMListByTypeId() {
        const params = {
          typeId: this.typeId
        }
        getListByTypeId(params).then(res => {
          const data = res.data.data ? res.data.data : [];
          if (data) {
            const reorderedArr = data.sort((a, b) => {
              if (a.name === '其他') return 1;
              if (b.name === '其他') return -1;
              return 0;
            });

            const newData = reorderedArr.map(item => {
              return {
                key: item.id,
                type: item.name,
                malfunctionIds: item.malfunctionIds
              }
            });

            this.orderTypeList = newData

            this.hasMalfunctionImplementatioIds = newData.filter(item => item.malfunctionIds).map(item => item
              .key);
          } else {
            this.openTip(1)
          }
        })
      },
      openTip(i) {
        let msg = '';
        switch (i) {
          case 1:
            msg = '该订单暂无履约类型'
            break;
          case 2:
            msg = '该履约类型无故障类型'
            break;
          default:
            break;
        }
        this.$notify.info({
          title: '消息',
          message: msg
        });
      },
      getMalfunctionListFun() {
        getMalfunctionList().then((res) => {
          this.malfunctionList = res.data.data;
          const colume = [];
          const map = {};
          this.malfunctionList.forEach((v) => {
            colume.push({
              value: v.id,
              text: v.name
            });
            map[v.id] = v.amount;
          });

          this.initMalfunctionColumn = JSON.parse(JSON.stringify(colume))

          this.malfunctionColumn = colume;
          this.malfunctionMap = map;
        });
      },
      getMalfunctionListByKey(implementationId = null) {
        const params = {
          id: implementationId
        }
        getMalfunctionListByImplementationId(params).then(res => {
          const colume = [];
          const map = {};
          const data = res.data.data ? res.data.data : []
          if (data) {
            data.forEach((v) => {
              colume.push({
                value: v.id,
                text: v.name
              });
              map[v.id] = v.amount;
            });
            this.malfunctionColumn = colume;
          } else {
            this.openTip(2)
          }
        })
      },
      getModelListFun() {
        getModelList().then((res) => {
          this.modelList = res.data.data;
          const colume = [];
          const map = {};
          this.modelList.forEach((v) => {
            colume.push({
              value: v.id,
              text: v.name,
              newAmount: v.newAmount,
              oldAmount: v.oldAmount,
            });
            map[v.id] = v;
          });
          this.modelColumn = colume;
          this.modelMap = map;
        });
      },
      formulaCalc() {
        return "";
      },
      formulaCalc2() {
        return "";
      },
      getFormulaFun() {
        getFormula().then((res) => {
          const formula = res.data.data.key;
          const funtionStr = `function test(x,y,z) { return ${formula}}`;
          // eslint-disable-next-line no-new-func
          this.formulaCalc = new Function("return " + funtionStr)();
        });
        getFormula2().then((res) => {
          const formula2 = res.data.data.key;
          const funtionStr = `function test(x,y,z) { return ${formula2}}`;
          // eslint-disable-next-line no-new-func
          this.formulaCalc2 = new Function("return " + funtionStr)();
        });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  .wrapper {
    background: url("https://www.servicefun.cn/static/img/bg.png") no-repeat;
    overflow: auto;
    background-size: 100%;
    background-color: #f0f0f0;

    .formWrapper {
      width: 340px;
      background: #fff;
      margin: 0 auto;
      margin-top: 36px;
      border-radius: 10px;
      overflow: hidden;
      padding-bottom: 20px;
    }

    .icon-box {
      padding: 10px 16px;
    }

    .panel {
      .title {
        padding: 10px 16px;
      }

      /deep/ .van-uploader {
        width: 300px;
        padding: 10px 16px;
      }

      .upladerBtn {
        background-color: #e2e2e2;
        border: none;
        font-size: 40px;
        width: 300px;
        height: 240px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .upladerBtn1 {
        background-image: url(https://www.servicefun.cn/static/img/1.png);
      }

      .upladerBtn2 {
        background-image: url(https://www.servicefun.cn/static/img/2.png);
      }

      .upladerBtn3 {
        background-image: url(https://www.servicefun.cn/static/img/3.png);
      }

      .upladerBtn4 {
        background-image: url(https://www.servicefun.cn/static/img/4.png);
      }

      .upladerBtn5 {
        background-image: url(https://www.servicefun.cn/static/img/5.png);
      }

      .upladerBtn6 {
        background-image: url(https://www.servicefun.cn/static/img/6.png);
      }

      .upladerBtn7 {
        background-image: url(https://www.servicefun.cn/static/img/7.png);
      }

      .upladerBtn8 {
        background-image: url(https://www.servicefun.cn/static/img/8.png);
      }

      .upladerBtn9 {
        background-image: url(https://www.servicefun.cn/static/img/9.png);
      }

      .upladerBtn10 {
        background-image: url(https://www.servicefun.cn/static/img/10.png);
      }
      .upladerBtn11 {
        background-image: url(https://www.servicefun.cn/static/img/10.png);
      }

      .upladerBtn12 {
        background-image: url(https://www.servicefun.cn/static/img/11.png);
      }
    }

    .discription {
      padding: 10px 16px;
      font-size: 12px;
      color: #908c8c;


      p {
        margin-top: 6px;
        line-height: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/guarantee/index.vue